import ULThemeSeparator from "@/components/ULThemeSeparator";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";
import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import AlternativeLogins from "./components/AlternativeLogins";
import LoginForm from "./components/LoginForm";
import { useLoginManager } from "./hooks/useLoginManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function LoginScreen() {
    // Extracting attributes from hook made out of LoginInstance class of Auth0 React ACUL SDK
    const { login, texts, locales, alternateConnections } = useLoginManager();

    const showSeparator = alternateConnections && alternateConnections.length > 0;

    const separatorText = texts?.separatorText || locales?.page?.orText;
    applyAuth0Theme(login);

    const socialLoginAlignment = extractTokenValue(
        "--ul-theme-widget-social-buttons-layout"
    );

    const renderSocialLogins = (alignment: "top" | "bottom") => (
        <>
            {alignment === "bottom" && showSeparator && (
                <ULThemeSeparator text={separatorText} />
            )}
            <AlternativeLogins />
            {alignment === "top" && showSeparator && (
                <ULThemeSeparator text={separatorText} />
            )}
        </>
    );

    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales?.page?.title}>

            {socialLoginAlignment === "top" && renderSocialLogins("top")}
            <LoginForm />
            {socialLoginAlignment !== "top" && renderSocialLogins("bottom")}

        </AuthLayout>
    );
}

export default LoginScreen;
